import Link from 'next/link';
import type { MenuProps } from 'antd';
import IntlMessages from '../Locale/IntlMessages';
import { HopTuanIcon, ReportIcon } from '../Icons/NavbarIcon';

type BaseMenuItem = Required<MenuProps>['items'][number];
type BscStepMenuItem = BaseMenuItem & {
    modulename?: string;
    checklicense?: boolean;
    children?: BscStepMenuItem[];
};

/** Triển khai BSC (8 bước) + nhóm Báo cáo — chỉ gắn vào menu khi phân hệ BSC. */
export const BscStepMenus: BscStepMenuItem[] = [
    {
        key: 'trien-khai-bsc',
        label: <IntlMessages id="bsc.menu.trien-khai-bsc" text="Triển Khai BSC" />,
        type: 'group' as const,
        children: [
            {
                key: 'b1-danh-gia',
                modulename: 'buoc1,b1.danhgia',
                checklicense: true,
                label: (
                    <Link href="/danh-gia">
                        <IntlMessages id="bsc.label.danhgia" text="Đánh giá" />
                    </Link>
                ),
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        1
                    </span>
                ),
            },
            {
                key: 'b2-xay-dung-chien-luoc',
                label: <IntlMessages id="bsc.menu.xay-dung-chien-luoc" text="Xây dựng Chiến lược" />,
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        2
                    </span>
                ),
                children: [
                    {
                        key: 'b2-swot',
                        modulename: 'buoc2swot,b2.swot',
                        checklicense: true,
                        label: (
                            <Link href="/xay-dung-chien-luoc/swot">
                                <IntlMessages id="bsc.menu.phan-tich-swot" text="Phân tích SWOT" />
                            </Link>
                        ),
                    },
                    {
                        key: 'b2-chien-luoc',
                        modulename: 'buoc2chienluoc,b2.xaydungchienluoc',
                        checklicense: true,
                        label: (
                            <Link href="/xay-dung-chien-luoc/chien-luoc">
                                <IntlMessages id="bsc.menu.xay-dung-chien-luoc" text="Xây dựng Chiến lược" />
                            </Link>
                        ),
                    },
                ],
            },
            {
                key: 'b3-ket-qua-chien-luoc',
                label: <IntlMessages id="bsc.menu.ket-qua-chien-luoc" text="Kết quả chiến lược" />,
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        3
                    </span>
                ),
                children: [
                    {
                        key: 'b3-lua-chon',
                        modulename: 'buoc3,b3.luachonketqua',
                        checklicense: true,
                        label: (
                            <Link href="/ket-qua-chien-luoc/lua-chon">
                                <IntlMessages id="bsc.menu.lua-chon-chien-luoc" text="Lựa chọn chiến lược" />
                            </Link>
                        ),
                    },
                    {
                        key: 'b3-ket-qua',
                        modulename: 'buoc3,b3.ketquachienluoc',
                        checklicense: true,
                        label: (
                            <Link href="/ket-qua-chien-luoc/ket-qua">
                                <IntlMessages id="bsc.menu.ket-qua-chien-luoc" text="Kết quả chiến lược" />
                            </Link>
                        ),
                    },
                ],
            },
            {
                key: 'b4-ban-do-chien-luoc',
                label: <IntlMessages id="bsc.label.bandochienluoc" text="Bản Đồ Chiến Lược" />,
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        4
                    </span>
                ),
                children: [
                    // ...(isAdmin
                    // ? [
                    {
                        key: 'b4-thanh-phan',
                        modulename: 'buoc4thanhphan,b4.bandochienluocthanhphan',
                        checklicense: true,
                        label: (
                            <Link href="/ban-do-chien-luoc-thanh-phan">
                                <IntlMessages id="bsc.label.thanhphan" text="Thành phần" />
                            </Link>
                        ),
                    },
                    // ]
                    // : []),
                    {
                        key: 'b4-cong-ty',
                        modulename: 'buoc4,b4.bandochienluoccongty',
                        checklicense: true,
                        label: (
                            <Link href="/ban-do-chien-luoc">
                                <IntlMessages id="bsc.label.congty" text="Công ty" />
                            </Link>
                        ),
                    },
                ],
            },
            {
                key: 'b5-mo-hinh-xuong-ca',
                modulename: 'buoc5,b5.mohinhxuongxa',
                checklicense: true,
                label: (
                    <Link href="/buoc5">
                        <IntlMessages id="bsc.label.mohinhxuongca" text="Mô hình Xương cá" />
                    </Link>
                ),
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        5
                    </span>
                ),
            },
            {
                key: 'b6-do-luong-chi-tieu',
                modulename: 'buoc6,b6.doluongchitieu',
                checklicense: true,
                label: (
                    <Link href="/buoc6">
                        <IntlMessages id="bsc.btn.doluongchitieu" text="Đo Lường & Chỉ Tiêu" />
                    </Link>
                ),
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        6
                    </span>
                ),
            },
            {
                key: 'b7-phan-bo-ti-trong',
                modulename: 'buoc7,b7.phanbotitrong',
                checklicense: true,
                label: (
                    <Link href="/buoc7">
                        <IntlMessages id="bsc.label.phanbotitrong" text="Phân bổ Tỉ trọng" />
                    </Link>
                ),
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        7
                    </span>
                ),
            },
            {
                key: 'b8-action-plan',
                modulename: 'buoc9,b8.actionplan',
                checklicense: true,
                label: (
                    <Link href="/du-an">
                        <IntlMessages id="bsc.text.hoptuan.actionplan" text="Action plan" />
                    </Link>
                ),
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        8
                    </span>
                ),
            },
            {
                key: 'b8-action-plan-v2',
                modulename: 'buoc9,b8.actionplan',
                checklicense: true,
                label: (
                    <Link href="/action-plan-v2?view=employee">
                        <IntlMessages id="bsc.text.hoptuan.actionplan" text="Action plan" />
                    </Link>
                ),
                icon: (
                    <span className="!text-[10px] rounded-full border-2 border-[#0c68e9] bg-[#e8f1fd] !text-[#0c68e9] w-[18px] h-[18px] flex items-center justify-center font-semibold">
                        8
                    </span>
                ),
            },
            {
                key: 'b9-phong-cach-van-hoa',
                modulename: 'buoc9,b9.phongcachvanhoa',
                checklicense: true,
                alertDemo: true,
                label: <IntlMessages id="bsc.menu.phong-cach-lanh-dao-&-van-hoa" text="Phong Cách Lãnh Đạo & Văn Hóa" />,
                icon: (
                    <span className="!text-[10px] rounded-full bg-[#0c68e9] !text-white w-[18px] h-[18px] flex items-center justify-center">
                        9
                    </span>
                ),
            },
        ],
    },
    {
        key: 'reports',
        label: <IntlMessages id="bsc.menu.bao-cao" text="Báo Cáo" />,
        type: 'group' as const,
        children: [
            {
                key: 'report',
                modulename: 'buoc11,baocao.baocaokpi',
                checklicense: true,
                label: (
                    <Link href="/bao-cao-kpis">
                        <IntlMessages id="bsc.menu.bao-cao-kpis" text="Báo Cáo KPIs" />
                    </Link>
                ),
                icon: (
                    <span>
                        <ReportIcon />
                    </span>
                ),
            },
            {
                key: 'statistic',
                modulename: 'buoc11dashboard,baocao.thongkebaocaokpi',
                checklicense: true,
                alertDemo: true,
                label: (
                    <Link href="/thong-ke-bao-cao-kpis">
                        <IntlMessages id="bsc.menu.thong-ke-bao-cao-kpi" text="Thống kê báo cáo KPI" />
                    </Link>
                ),
                icon: (
                    <span>
                        <HopTuanIcon />
                    </span>
                ),
            },
            {
                key: 'kpi-khong-dat',
                modulename: 'dashboard,buoc11,baocao.baocaokpi',
                checklicense: true,
                label: (
                    <Link href="/thong-ke-kpi-khong-dat">
                        <IntlMessages id="bsc.menu.thong-ke-kpi-khong-dat" text="KPI không đạt" />
                    </Link>
                ),
                icon: (
                    <span>
                        <ReportIcon />
                    </span>
                ),
            },
            {
                key: 'sumary',
                modulename: 'buoc15,baocao.tonghop',
                checklicense: true,
                alertDemo: true,
                label: (
                    <Link href="/tong-hop-ca-nhan">
                        <IntlMessages id="bsc.label.tonghop" text="Tổng hợp" />
                    </Link>
                ),
                icon: (
                    <span>
                        <HopTuanIcon />
                    </span>
                ),
            },
        ],
    },
];
